module.exports = __webpack_public_path__ + "static/media/mobile_trivy.2fa718a3.png";